<svg width="26" height="18" viewBox="0 0 26 18" fill="none" xmlns="http://www.w3.org/2000/svg">
	<g clip-path="url(#clip0_6981_16648)">
		<line x1="1.06066" y1="7.93934" x2="10.0607" y2="16.9393" stroke="#8F00FF" stroke-width="3" />
		<line
			y1="-1.5"
			x2="12.7279"
			y2="-1.5"
			transform="matrix(0.707107 -0.707107 -0.707107 -0.707107 0 9)"
			stroke="#8F00FF"
			stroke-width="3"
		/>
		<line x1="2.5" y1="9" x2="25.5" y2="9" stroke="#8F00FF" stroke-width="3" />
	</g>
	<defs>
		<clipPath id="clip0_6981_16648">
			<rect width="26" height="18" fill="white" />
		</clipPath>
	</defs>
</svg>
